import { IGraphData, IDomain } from "@/class/models/typed/gadget/basicGadget";

/**
 * ガジェット（ダッシュボードのグラフ）の作成者基底クラス。
 */
export abstract class GadgetMakerBase
{
  protected gadgetDatas: IGraphData[];
  protected materials: IDomain[];

  constructor(gadget_datas: IGraphData[], materials: IDomain[])
  {
    this.gadgetDatas = gadget_datas;
    this.materials = materials;
  }

  /**
   * [abstract] Chart.jsオプションの生成。
   * @param src_option_obj 元になるオプション。新規設定を加えて新規オプションを返却する。
   */
  abstract generateOptionObj(src_option_obj: Readonly<any>) : any
}
